import { TemplateElement, html, defineElement } from '@webtides/element-js';

/**
 * @property {string} message
 * @property {string} pageId
 * @property {boolean} watching
 * @property {string} storageKey
 */
export default class LikeButton extends TemplateElement {
    /** @type TooltipElement */
    tooltipElement;

    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            message: '',
            pageId: '',
            watching: false,
            storageKey: 'watchedPages',
        };
    }

    connected() {
        this.tooltipElement = this.$refs.tooltip;

        const watchedPages = new Set(JSON.parse(window.localStorage.getItem(this.storageKey)));

        if (watchedPages.has(this.pageId)) {
            this.watching = true;
        }
    }

    events() {
        return {
            this: {
                click: (e) => {
                    e.preventDefault();
                    this.watching ? this.removeFromFavorites() : this.addToFavorites();
                },
                focusout: () => {
                    this.tooltipElement.hide();
                },
            },
            document: {
                'watch-page': ({ detail }) => {
                    if (detail.pageId === this.pageId) {
                        this.watching = detail.watching;
                    }
                },
            },
        };
    }

    addToFavorites() {
        const watchedPages = new Set(JSON.parse(window.localStorage.getItem(this.storageKey)));
        watchedPages.add(this.pageId);
        window.localStorage.setItem(this.storageKey, JSON.stringify(Array.from(watchedPages)));

        this.watching = true;
        this.tooltipElement.show();

        this.requestUpdate().then(() => {
            this.querySelector('button[slot="unwatch"]').focus();
        })

        this.dispatch('watch-page', { pageId: this.pageId, watching: this.watching });
    }

    removeFromFavorites() {
        const watchedPages = new Set(JSON.parse(window.localStorage.getItem(this.storageKey)));
        watchedPages.delete(this.pageId);
        window.localStorage.setItem(this.storageKey, JSON.stringify(Array.from(watchedPages)));
        this.watching = false;
        this.requestUpdate().then(() => {
            this.querySelector('button[slot="watch"]').focus();
        })
        this.dispatch('watch-page', { pageId: this.pageId, watching: this.watching });
    }

    template() {
        return html`
            <tooltip-element ref="tooltip" trigger="manual" content="${this.message}">
                <slot name="${this.watching ? 'unwatch' : 'watch'}"></slot>
            </tooltip-element>
        `;
    }
}

defineElement('like-button', LikeButton);
